module.exports = __webpack_public_path__ + "275f6e386eb03f4860c7e0402ba40a8e.pdf";